import React, { useState, useEffect } from 'react';

export const RotateHint = () => {
  const [isPortrait, setIsPortrait] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const checkOrientation = () => {
      const isMobile = window.innerWidth < 768;
      const portrait = window.innerHeight > window.innerWidth;
      setIsPortrait(isMobile && portrait);
    };

    checkOrientation();
    window.addEventListener('resize', checkOrientation);
    window.addEventListener('orientationchange', () => {
      setTimeout(checkOrientation, 100);
    });

    return () => {
      window.removeEventListener('resize', checkOrientation);
      window.removeEventListener('orientationchange', checkOrientation);
    };
  }, []);

  if (!isPortrait || dismissed) return null;

  return (
    <div
      data-testid="rotate-hint"
      className="flex items-center gap-3 px-3 py-2 mb-2 rounded-lg bg-emerald-900/40 border border-emerald-700/30 text-emerald-300 text-xs md:hidden animate-in fade-in slide-in-from-top-2"
    >
      <svg
        width="22"
        height="22"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="shrink-0 animate-pulse"
      >
        <rect x="4" y="2" width="16" height="20" rx="2" />
        <path d="M12 18h.01" />
        <path d="M20 14l2-2-2-2" className="animate-bounce" />
      </svg>
      <span>
        <strong>Tip:</strong> Rotate your phone sideways for the best tab view
      </span>
      <button
        onClick={() => setDismissed(true)}
        className="ml-auto shrink-0 p-1 rounded hover:bg-emerald-800/50 transition-colors"
        aria-label="Dismiss rotate hint"
        data-testid="rotate-hint-dismiss"
      >
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
          <path d="M18 6L6 18M6 6l12 12" />
        </svg>
      </button>
    </div>
  );
};
